// TODO: update configs for product collection

import { PlanLimitConfigs, BillingCycleConfig } from '../types.js';

export const PRODUCT_COLLECTION_DEFAULT_BILLING_CYCLE = 'MONTHLY';
export const PRODUCT_COLLECTION_DEFAULT_UNIT_COUNT = 300;

export const PRODUCT_COLLECTION_MIN_ENTERPRISE_USER_COUNT = 801;

export const productCollectionOfferingSkus = {
	free: 'product-collection-free-sku',
	standard: 'product-collection-standard-sku',
	premium: 'product-collection-premium-sku',
	enterprise: 'product-collection-enterprise-sku',
} as const;

export const productCollectionOfferingSkusArray = Object.values(productCollectionOfferingSkus);

export const productCollectionPlanLimitConfigs: PlanLimitConfigs[] = [
	{
		planName: 'Free',
		offeringSku: productCollectionOfferingSkus.free,
		recommendationLimit: 0,
		signupLimit: 10,
	},
	{
		planName: 'Standard',
		offeringSku: productCollectionOfferingSkus.standard,
		recommendationLimit: 0,
		signupLimit: 100_000,
	},
	{
		planName: 'Premium',
		offeringSku: productCollectionOfferingSkus.premium,
		recommendationLimit: 0,
		signupLimit: 100_000,
	},
	{
		planName: 'Enterprise',
		offeringSku: productCollectionOfferingSkus.enterprise,
		recommendationLimit: 5000,
		signupLimit: 100_000,
		minUnitCount: PRODUCT_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
	},
];

export const productCollectionBillingCycleConfig: BillingCycleConfig = {
	monthly: true,
	annual: true,
};
